var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslTab, CpslTabs } from '@usecapsule/react-components';
import { useEffect, useState } from 'react';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { Heading, SecondaryText, MainContainer, QRContainer, ButtonWithIconContainer, Hero, CreationStepSubheading, FilledDisabledInput, } from '../common.js';
import { openPopup } from '../../utils/openPopup.js';
import { styled } from 'styled-components';
import { isMobileBrowser } from '../../utils/isMobile.js';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard.js';
const SHORTENING_AVAILABLE = true;
export const BiometricCreationStep = ({ hasFinishedAnimation }) => {
    const webAuthURLForCreate = useModalStore(state => state.webAuthURLForCreate);
    const currentStep = useModalStore(state => state.step);
    const setStep = useModalStore(state => state.setStep);
    const capsule = useCapsuleStore(state => state.capsule);
    const [copied, copy] = useCopyToClipboard();
    const [tab, setTab] = useState('desktop');
    const [shortLoginLink, setShortLoginLink] = useState();
    const isMobile = isMobileBrowser();
    useEffect(() => {
        if (currentStep !== ModalStep.BIOMETRIC_LOGIN) {
            setShortLoginLink(null);
        }
        if (!webAuthURLForCreate) {
            return;
        }
        function shortenUrl() {
            return __awaiter(this, void 0, void 0, function* () {
                const shortUrl = yield capsule.shortenLoginLink(webAuthURLForCreate);
                setShortLoginLink(shortUrl);
            });
        }
        if (SHORTENING_AVAILABLE) {
            shortenUrl();
        }
        else {
            setShortLoginLink(webAuthURLForCreate);
        }
    }, [webAuthURLForCreate]);
    const handlePasskeyClick = () => {
        openPopup(shortLoginLink, 'CapsulePasskey', 'CREATE_PASSKEY');
        setStep(ModalStep.AWAITING_BIOMETRIC_CREATION);
    };
    const handleTabChanged = (event) => {
        setTab(event.detail.tab);
    };
    const handleCopy = () => {
        copy(shortLoginLink);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Hero, { icon: "heroPasskey" }), _jsxs(MainContainer, { children: [_jsx(Heading, { children: _jsx("span", { children: "Create Passkey" }) }), _jsx(CreationStepSubheading, { children: _jsx("span", { children: isMobile
                                ? 'A Passkey will be created and stored on this device.'
                                : 'You can create a Passkey on this device or your phone.' }) })] }), !isMobile && (_jsx(TabsContainer, { children: _jsxs(CpslTabs, { selectedTab: hasFinishedAnimation ? tab : '', onCpslTabsChanged: handleTabChanged, fullWidth: true, children: [_jsx(CpslTab, { tab: "desktop", children: "Desktop" }), _jsx(CpslTab, { tab: "phone", children: "Phone" })] }) })), tab === 'desktop' || isMobile ? (_jsx(CpslButton, { fullWidth: true, onClick: handlePasskeyClick, children: _jsxs(ButtonWithIconContainer, { children: ["Add Passkey On This Device", _jsx(CpslIcon, { icon: "key" })] }) })) : (_jsxs(_Fragment, { children: [_jsx(QRContainer, { children: !shortLoginLink ? _jsx(CpslSpinner, {}) : _jsx(CpslQrCode, { url: shortLoginLink }) }), _jsx(SecondaryText, { children: _jsx("span", { children: "Scan with your phone\u2019s camera" }) })] })), isMobile && (_jsxs(_Fragment, { children: [_jsx(MobileSubHeading, { children: _jsx("span", { children: "Or copy this link to a new device to set up a Passkey there." }) }), _jsx(FilledDisabledInput, { disabled: true, value: shortLoginLink, noAutoDisable: true, children: _jsx(CpslButton, { slot: "end", variant: "ghost", onClick: handleCopy, children: _jsx(CpslIcon, { icon: copied ? 'check' : 'copy' }) }) })] }))] }));
};
const TabsContainer = styled.div `
  align-self: center;
  width: 218px;
  max-width: 218px;
`;
const MobileSubHeading = styled(SecondaryText) `
  align-self: center;
  width: 220px;
`;
